import Vue from 'vue'
import App from './App.vue'
import router from './shared/router'
import store from './shared/store'

// api
import '@/shared/services/api'

// plugins
import '@/shared/plugins'

/// layout AdminLTE
import './shared/layouts/adminlte'

// filters
import '@/shared/common/filters'

import '@/shared/assets/css/main.scss'

// Configurações do módulo
Vue.prototype.$urlBase = process.env.VUE_APP_FRONT_URL_AGENDA_PRO
Vue.prototype.$urlExternalFiles = ''

new Vue({
    router,
    store: store,
    render: h => h(App)
}).$mount('#app')
